import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { toFixed } from "@/utils/utilities";


export default /*#__PURE__*/_defineComponent({
  __name: 'cyberHealthScoreChart',
  props: {
    currentScore: { default: 0 },
    potentialScore: { default: 0 },
    totalScore: { default: 0 },
    pcntScore: { default: 0 },
    isLoading: { type: Boolean },
    noteColor: { default: "#211f58" },
    currentScoreColor: { default: "#48A0FF" },
    totalScoreColor: { default: "#D9EDE2" }
  },
  setup(__props: any) {

const props = __props;



const percent = ref(0);

const optionsCurrent = computed(() => ({
  colors: [props.currentScoreColor],
  plotOptions: {
    radialBar: {
      startAngle: -90,
      endAngle: 90,
      hollow: {
        size: "75%",
      },
      track: {
        background: "#F1F2F3",
        opacity: 1,
        show: props.currentScore > props.potentialScore,
      },
      dataLabels: {
        name: {
          show: false,
        },
        value: {
          show: true,
          color: "#211F58",
          fontSize: "56px",
          fontWeight: 400,
          fontFamily: "Poppins",
          offsetY: -35,
          formatter: () => `${toFixed(percent.value)}%`,
        },
      },
    },
  },
  stroke: {
    show: true,
    lineCap: "round",
    opacity: 1,
  },
  fill: {
    opacity: 1,
  },
  labels: ["current"],
}));

const optionsPotential = {
  colors: [props.totalScoreColor],
  plotOptions: {
    radialBar: {
      startAngle: -90,
      endAngle: 90,
      hollow: {
        size: "75%",
      },
      track: {
        background: "#F1F2F3",
        opacity: 1,
        show: props.potentialScore >= props.currentScore,
      },
      dataLabels: {
        name: {
          show: false,
        },
        value: {
          show: false,
          color: "#211F58",
          fontSize: "30px",
          fontWeight: 400,
          fontFamily: "Poppins",
          offsetY: -55,
          formatter: () => `%`,
        },
      },
    },
  },
  stroke: {
    show: true,
    lineCap: "round",
    opacity: 1,
  },
  fill: {
    opacity: 1,
  },
  labels: ["potential"],
};

const series = computed(() => {
  const current = toFixed((props.currentScore * 100) / props.totalScore);
  const potential = toFixed((props.potentialScore * 100) / props.totalScore);
  return [current, potential];
});

let timeout: any;

const updateNode = async () => {
  const [nodeValue, nodePercent]: any = document.querySelectorAll(
    ".apexcharts-datalabel-value",
  );
  if (nodeValue && nodePercent) {
    const nodeValueWith = nodeValue.getBoundingClientRect()?.width;
    const nodeValueX = nodeValue.getAttributeNode("x")?.value;
    nodePercent?.setAttribute(
      "x",
      `${Number(nodeValueX) + Number(nodeValueWith) / 2 + 15}`,
    );
    setTimeout(() => {
      nodeValue?.setAttribute("fill", props.noteColor);
      nodePercent?.setAttribute("fill", props.noteColor);
    }, 50);
  }
};

const debounce = (timer = 1000, callback?: () => void) => {
  return new Promise((resolve) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => resolve(callback?.()), timer);
  });
};

const resize = () => {
  debounce(200, updateNode);
};

onMounted(() => {
  window.addEventListener("resize", resize);
  EventEmitter.on(EmitterEvents.UPDATE_CHEVRON_ACTIVE, resize);
  percent.value = props.pcntScore;
  resize();
});

onUnmounted(() => {
  window.removeEventListener("resize", resize);
  EventEmitter.off(EmitterEvents.UPDATE_CHEVRON_ACTIVE);
});

watch(
  () => props.pcntScore,
  () => {
    percent.value = props.pcntScore;
  },
  {
    immediate: true,
  },
);

watch(percent, () => {
  resize();
});

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_apexchart, {
      class: _normalizeClass(`${
      _ctx.currentScore < _ctx.potentialScore ? 'score-chart-short' : 'score-chart-full'
    }`),
      style: _normalizeStyle(`z-index: ${_ctx.currentScore < _ctx.potentialScore ? 1 : 0}`),
      width: "480px",
      type: "radialBar",
      options: optionsCurrent.value,
      series: [series.value[0]]
    }, null, 8, ["class", "style", "options", "series"]),
    _createVNode(_component_apexchart, {
      class: _normalizeClass(`${
      _ctx.potentialScore < _ctx.currentScore ? 'score-chart-short' : 'score-chart-full'
    }`),
      style: _normalizeStyle(`z-index: ${_ctx.potentialScore < _ctx.currentScore ? 1 : 0}`),
      width: "480px",
      type: "radialBar",
      options: optionsPotential,
      series: [series.value[1]]
    }, null, 8, ["class", "style", "series"])
  ], 64))
}
}

})